/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxTooltipComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtooltip';

/**
 * Tooltip
 */
@Component({
    selector: 'ngc-tooltip',
    template: `<jqxTooltip
                [absolutePositionX] = "absolutePositionX"
                [absolutePositionY] = "absolutePositionY"
                [autoHide] = "autoHide"
                [autoHideDelay] = "autoHideDelay"
                [animationShowDelay] = "animationShowDelay"
                [animationHideDelay] = "animationHideDelay"
                [content] = "content"
                [closeOnClick] = "closeOnClick"
                [disabled] = "disabled"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [left] = "left"
                [name] = "name"
                [opacity] = "opacity"
                [position] = "position"
                [rtl] = "rtl"
                [showDelay] = "showDelay"
                [showArrow] = "showArrow"
                [top] = "top"
                [trigger] = "trigger"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxTooltip>`
})
export class NgcToolTipComponent extends ControlComponent {
    @Input('absolutePositionX') absolutePositionX: any;
    @Input('absolutePositionY') absolutePositionY: any;
    @Input('autoHide') autoHide: any;
    @Input('autoHideDelay') autoHideDelay: any;
    @Input('animationShowDelay') animationShowDelay: any;
    @Input('animationHideDelay') animationHideDelay: any;
    @Input('content') content: any;
    @Input('closeOnClick') closeOnClick: any;
    @Input('disabled') disabled: any;
    @Input('enableBrowserBoundsDetection') enableBrowserBoundsDetection: any;
    @Input('left') left: any;
    @Input('name') name: any;
    @Input('opacity') opacity: any;
    @Input('position') position: any;
    @Input('rtl') rtl: any;
    @Input('showDelay') showDelay: any;
    @Input('showArrow') showArrow: any;
    @Input('top') top: any;
    @Input('trigger') trigger: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Tooltip Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcToolTipComponent],
    declarations: [NgcToolTipComponent, jqxTooltipComponent]
})
export class NgcTooltipModule {
}